import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import '../css/UpdateUserProfile.css'; 
import { Card, Row } from 'react-bootstrap';
import queryString from 'query-string';
import axiosConfig from '../config/axiosConfig'
import { sha256 } from 'js-sha256';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import auth from "../auth";


class SetPassword extends React.Component {
    constructor(props) {
        super(props);
        
        this.state={
            password:'',
            cpassword:'',
            userid:0,
            errors: {},
            IsUserVerfied:false,
            Token:'',
            UserToken: '',
            loading: true,
           }
           
        this.changeHandler=this.changeHandler.bind(this);
        this.submitHandler=this.submitHandler.bind(this);
    }

    componentDidMount() {

        const parsed = queryString.parse(this.props.location.search);
        
        this.setState({ UserToken:  parsed["Token"]});

        setTimeout(() => {
                  this.VerifyUser(parsed["Token"]);
             }, 500);
    }

   async VerifyUser(token)
    {
        Swal.fire({
            title: 'Please Wait ...',
            onBeforeOpen() {
                Swal.showLoading()
            },
            onAfterClose() {
                Swal.hideLoading()
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: false,
            showConfirmButton: false
        })


        const data = {
            Token:token,
        }
        
        await axiosConfig.post('User/VerifyUser', data)
            .then(res => {

                Swal.close();

                this.setState({ userid:  res.data.userId});
                this.setState({ IsUserVerfied:  true});
                this.setState({Token:res.data.token});
                this.setState({loading: false});

            }
            )
            .catch(error => {

                console.log('exception error', error.response.data);

                Swal.fire({
                    text: error.response.data.status.description,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                }).then(function() {
                    window.location = "/Login";
                });

                
            })
    }

    changeHandler(p) { 
                 var newState = {};
                 newState[p.target.name] = p.target.value;
                 this.setState(newState);     
                }

    submitHandler= e =>{
        e.preventDefault();
        if(this.validate() && this.state.IsUserVerfied){

        const data = {
            UserToken: this.state.UserToken,
            Password:sha256(this.state.password), 
        }

        axiosConfig.post('User/SetPassword', data)
            .then(res => {
                debugger
                Swal.fire({
                    text: 'Password has been changed',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(function() {
                    window.location = "/Login";
                });

            }
            )
            .catch(error => {
                debugger
                if(error.response.status == '403' || error.response.status == '401')
                {
                    Swal.fire({
                        text: error.response.data.errorMessage                        ,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                        auth.logout(() => {
                            this.props.history.push("/Login");
                        })
                }

                Swal.fire({
                    text: error.response.data.errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })

                
            })
      }
    }

    

       validate(){
        let input = this.state;
        let errors = {};
        let isValid = true;
     
      

        if(input["password"].length < 8)
        {
            isValid = false;
            errors["password"] = "Your password must be atleast 8 character long.";
            this.setState({
                errors: errors
              });
            return;
        }

        if(!input["password"].match(/[A-Z]/))
        {
            isValid = false;
            errors["password"] = "Your password must contain at least 1 uppercase letter.";
            this.setState({
                errors: errors
              });
            return;
        }
        if(!input["password"].match(/[a-z]/))
        {
            isValid = false;
            errors["password"] = "Your password must contain at least 1 lowercase letter.";
            this.setState({
                errors: errors
              });
            return;
        }
        if(!input["password"].match(/[\d`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/))
        {
            isValid = false;
            errors["password"] = "Your password must contain At least 1 number or special character";
            this.setState({
                errors: errors
              });
            return;
        }
        
        if (input["password"] !== "undefined" && input["cpassword"] !== "undefined") {
            
            if (input["password"] != input["cpassword"]) {
              isValid = false;
              errors["password"] = "Passwords don't match.";
              this.setState({
                errors: errors
              });
            return;
            }
          } 

        if(isValid)
        {
            errors = {};
            this.setState({
                errors: errors
              });
        }    
        return isValid;
    }



    render() {
        
          
          let colour1="red",colour2="red",colour3="red",colour4="red",colour5="red";
            if(this.state.password.length >= "8")
            {
                colour1="green";    
            }
            if(this.state.password.match(/[A-Z]/))
            {
                colour2="green";    
            }
            if(this.state.password.match(/[a-z]/))
            {
                colour3="green";    
            }
            if(this.state.password.match(/[\d`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/))
            {
                colour4="green";    
            }
            if(this.state.password === this.state.cpassword && this.state.password!=="" )
            {
                colour5="green";    
            }
      
        return (
            <>

        
        <section id="multiple-column-form">

            {this.state.loading === false && 

            <div className="row match-height">
                <div className="col-12">
                        <Card>
                            <Card.Title className="card-header">
                            Reset Password
                            </Card.Title>
                            <Card.Body>
                            <form className="form" onSubmit={this.submitHandler} >
                                <Row>
                                <p style={{fontWeight:"bold"}}>All checkmarks must turn green, password must have:</p>
                                </Row>
                                <Row>
                                    <p><i style={{color:colour1}} className="fa fa-check-circle" aria-hidden="true"></i> <small>At least 8 characters</small>   &nbsp;  </p> 
                                    <p><i style={{color:colour2}} className="fa fa-check-circle" aria-hidden="true"></i> <small> At least 1 uppercase letter</small> &nbsp;</p>
                                    <p><i style={{color:colour3}} className="fa fa-check-circle" aria-hidden="true"></i><small> At least 1 lowercase letter</small> &nbsp;</p>
                                    <p><i style={{color:colour4}} className="fa fa-check-circle" aria-hidden="true"></i><small> At least 1 number or special character</small> &nbsp;</p>
                                    <p><i style={{color:colour5}} className="fa fa-check-circle" aria-hidden="true"></i><small>Password is equal to Confirm Password</small> &nbsp;</p>
                                </Row>
                                <Row>
                                    <div className="col-md-6 col-12" id="text2">
                                        <div className="form-label-group">
                                            <input type="password" id="password" className="form-control" name="password" required value={this.state.password} onChange={this.changeHandler} placeholder="Enter New Password" />
                                            <label htmlFor="password">Enter New Password</label>
                                            <div className="text-danger pull-left">
                                            <small>
                                                 {this.state.errors.password}
                                            </small>
                                            </div>
                                        </div>
                                      
                                    </div>

                                </Row>
                                <Row>
                                    <div className="col-md-6 col-12" id="text2">
                                        <div className="form-label-group">
                                            <input type="password" id="cpassword" className="form-control" name="cpassword" required value={this.state.cpassword} onChange={this.changeHandler} placeholder="Confirm New Password" />
                                            <label htmlFor="cpassword">Confirm New Password</label>
                                            <div className="text-danger pull-left">
                                            <small>
                                                 {this.state.errors.cpassword}
                                            </small>
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                </Row>
                                <Row>
                                    <div className="col-12" style={{textAlign:'left'}}>
                                         <button type="submit" className="btn btn-shell mr-1 mb-1">Save</button>
                                    </div>
                                </Row>
                            </form>
                            </Card.Body>
                        </Card>
                </div>
            </div>

            }
        </section>
</>
            
            );
        }
    }
    
    export default SetPassword;









